import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Notification } from '@/components/Notification/Notification';
import { Typography } from '@/components/Typography/Typography';
import { FormikForm } from '@/components/form/FormikForm/FormikForm';
import { FormikInput } from '@/components/form/fields/FormikInput/FormikInput';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { ResponseErrorType } from '@/types/sharedTypes';
import { useFormik } from 'formik';
import { CreateOrganizationPayloadType } from '@/api/v1/organization/createOrganizationApi';
import { useEffect } from 'react';
import { object } from 'yup';

type CreateOrganizationModalType = {
  isOpen: boolean;
  apiError: ResponseErrorType;
  isLoading: boolean;
  onSubmit: (formValues: CreateOrganizationPayloadType) => void;
  onClose: () => void;
};

const validationSchema = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});

export const CreateOrganizationModal = ({
  isOpen,
  apiError,
  isLoading,
  onSubmit,
  onClose,
}: CreateOrganizationModalType) => {
  const formik = useFormik({
    initialValues: { name: '' },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  useEffect(() => {
    formik.resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const formError = getResponseError(apiError);

  return (
    <ModalWindow isOpen={isOpen} isStartPositionHeader width='504px'>
      <Typography variant='headline4' fontWeight='semibold' marginBottom='24px'>
        Create Organization
      </Typography>
      {formError && (
        <Notification variant='error' marginBottom='16px'>
          {formError}
        </Notification>
      )}
      <FormikForm value={formik}>
        <FormikInput name='name' label='Organization Name*' placeholder='Enter Organization Name' apiError={apiError} />

        <Box display='flex' flexDirection='column' width='100%' rowGap='12px'>
          <Button type='submit' disabled={!formik.isValid} isLoading={isLoading} mobileStretch>
            Submit
          </Button>
          <Button variant='secondary' onClick={onClose} mobileStretch>
            Cancel
          </Button>
        </Box>
      </FormikForm>
    </ModalWindow>
  );
};
